import { render, staticRenderFns } from "./ConsultantDetail.vue?vue&type=template&id=853a7e9c&scoped=true&"
import script from "./ConsultantDetail.vue?vue&type=script&lang=js&"
export * from "./ConsultantDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantDetail.vue?vue&type=style&index=0&id=853a7e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853a7e9c",
  null
  
)

export default component.exports